export class PayloadWrapper<T> implements IPayloadWrapper<T> {
    value: T
    constructor(value: T) {
        this.value = value;
    }
}

export interface IPayloadWrapper<T> {
    value: T
}
